module.exports = __webpack_public_path__ + "img/163.49a6c0ff.jpg";